import isExperienceEditor from "@utils/is-experience-editor";

(function (window) {

    var serviceSlider = function () {
        var menuStack = [];
        var ui = {};
        var isMobile;
        var SHOW_FULL_TEXT = 'collapsed';
        var MEDIA_QUERY = '(max-width: 991px)';
        var mql = window.matchMedia(MEDIA_QUERY);

        function cacheUI() {
            ui.$body = $('body');
            ui.$serviceSlider = $('.js-service-slider-filler');
            ui.$clientSlider = $('.js-service-slider');
            ui.$serviceSliderFilter = document.querySelector('.js-slider-filter .js-vca-dropdown-input');
            ui.$serviceSliderFilter2 = $('.js-slider-filter .js-vca-dropdown-input');
        }

        function initServiceSlider(e) {
            var serviceSlider = ui.$serviceSlider.each(function (index, element) {
                $(this).addClass('js-service-slider-filler' + index);
                var item_length = $('.js-service-slider-filler' + index + ' > div').length;
                if (item_length > 0 && !isExperienceEditor) {
                    $('.js-service-slider-filler' + index).slickFilterable({
                        filterName: 'filter-' + index,
                        filter: function( category, slider, settings ) {
                            return $(this).hasClass( category );
                        },
                        slick: {
                            dots: true,
                            arrows: true,
                            infinite: false,
                            slidesPerRow: 5,
                            rows: 2,
                            responsive: [
                                {
                                    breakpoint: 1279,
                                    settings: {
                                        slidesPerRow: 4
                                    }
                                },
                                {
                                    breakpoint: 991,
                                    settings: {
                                        slidesPerRow: 3
                                    }
                                },
                                {
                                    breakpoint: 767,
                                    settings: {
                                        slidesPerRow: 2,
                                        arrows: false
                                    }
                                },
                                {
                                    breakpoint: 575,
                                    settings: "unslick"
                                }
                            ]
                        }
                    });
                }
            });
        }

        function initClientSlider(e) {
            var clientSlider = ui.$clientSlider.each(function (index, element) {
                $(this).addClass('js-service-slider' + index);
                var item_length = $('.js-service-slider' + index + ' > div').length;
                if (item_length > 0 && !isExperienceEditor) {
                    $('.js-service-slider' + index).slick({
                        dots: true,
                        arrows: true,
                        infinite: false,
                        slidesPerRow: 5,
                        rows: 2, 
                        responsive: [
                            {
                                breakpoint: 1279,
                                settings: {
                                    slidesPerRow: 4
                                }
                            },
                            {
                                breakpoint: 991,
                                settings: {
                                    slidesPerRow: 3
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesPerRow: 2,
                                    arrows: false
                                }
                            },
                            {
                                breakpoint: 575,
                                settings: "unslick"
                            }
                        ]
                    });
                }
            });
        }


        function bindEvents() {
            //console.log('thing ',ui.$serviceSliderFilter);
        }

        function init() {
            cacheUI();
            bindEvents();
            initServiceSlider();
            initClientSlider();
        }

        return {
            init: init
        };
    };

    var serviceSlider = serviceSlider();
    serviceSlider.init();
})(window);